import { CreateNamedEntityDto } from './create-facility.dto';
import { CreateLocationDto } from '../location/create-location.dto';
import { ScopeOfPracticeEnum } from '@umss/shared/utils';
import {
  FacilityClassification,
  FacilityStatus,
  FacilityType
} from '@umss/shared/data-access';

export interface UpdateFacilityDto extends CreateNamedEntityDto {
  facilityTypeId?: FacilityType; // Required
  classification: FacilityClassification;
  status?: FacilityStatus; // Required
  location?: CreateLocationDto | null;
  contactPhone?: string | null; // Phone validation, max 20 characters
  contactEmail?: string | null; // Email validation, max 255 characters
  websiteUrl?: string | null; // URL validation
  isActive?: boolean; // Default true
  supportedScopes?: ScopeOfPracticeEnum[]; // Default empty array
}
